// extracted by mini-css-extract-plugin
export default {"background":"BoardCard_background__34vSt","container":"BoardCard_container__yzGL+","cardContent":"BoardCard_cardContent__iEtt9"};